import { styled } from 'next-yak';

export const Butterfly = styled.div``;
